import React from "react";
import Skeleton from 'react-loading-skeleton';
import ProfileTopCard from "./ProfileTopCard";
import ProfileHeaderSkeleton from "./ProfileHeaderSkeleton";
import MyPetCardSkeleton from "./MyPetCardSkeleton";
import MyPetListRowSkeleton from "./MyPetListRowSkeleton";

/**
 * Full page skeleton of Profile.jsx.
 */
export default function ProfileSkeleton() {
    return (
        <div className="space-y-3 sm:space-y-4">
            <ProfileTopCard
                stats={null}
                activeTab="pets"
                loading={true}
                header={<ProfileHeaderSkeleton />}
                onChangeTab={() => {}}
            />

            <div className="px-4 sm:px-6 lg:px-0 mt-6 sm:mt-28">
                <div className="mt-2 mb-4 sm:mb-4">
                    <Skeleton width={128} height={24} />
                </div>

                <section className="block">
                    <div className="space-y-4">
                        <div className="block sm:hidden space-y-0">
                            {[...Array(6)].map((_, i) => (
                                <MyPetListRowSkeleton key={i} />
                            ))}
                        </div>
                        <div className="hidden sm:grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 md:gap-2">
                            {[...Array(8)].map((_, i) => (
                                <MyPetCardSkeleton key={i} />
                            ))}
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}
